import Controller from "./cityCaptainVerification.controller";
import template from "./cityCaptainVerification.html";

const cityCaptainVerification = {
  template,
  controller: Controller,
  bindings: {
    cityId: "<",
  },
};

export default cityCaptainVerification;



// WEBPACK FOOTER //
// ./src/components/cityCaptainVerification/cityCaptainVerification.component.js